import { render, staticRenderFns } from "./template/index.html?vue&type=template&id=20927844&external"
import script from "./AddDiscountModal.vue?vue&type=script&lang=js"
export * from "./AddDiscountModal.vue?vue&type=script&lang=js"
import style0 from "./AddDiscountModal.vue?vue&type=style&index=0&id=20927844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports